import { createSlice } from '@reduxjs/toolkit'

const machineSlice = createSlice({
  name: 'machine',
  initialState: {
    selectedMachine: null,
    shouldAutoCreate: false,
  },
  reducers: {
    setSelectedMachine: (state, action) => {
      state.selectedMachine = action.payload
    },
    clearSelectedMachine: (state) => {
      state.selectedMachine = null
      state.shouldAutoCreate = false
    },
    requestAutoCreate: (state) => {
      if (state.selectedMachine) {
        state.shouldAutoCreate = true
      }
    },
    consumeAutoCreate: (state) => {
      state.shouldAutoCreate = false
    },
  },
})

export const { setSelectedMachine, clearSelectedMachine, requestAutoCreate, consumeAutoCreate } =
  machineSlice.actions

export default machineSlice.reducer
